import React, { useEffect, useState, useContext } from 'react'
import { defaultState, WebcastResponse } from '../libs/fetchWebcast'
import useWebcast from '../libs/useWebcast'
import { EnvVariablesContext } from '../contexts/EnvVariablesContext'

export interface WebcastSWR extends WebcastResponse {
  revalidate: () => Promise<boolean>
}

export const WebcastContext = React.createContext<WebcastSWR>({
  ...defaultState,
  revalidate: () => Promise.resolve(false)
})


const { Provider } = WebcastContext

const WebcastProvider = ({ value, children}) => {

  const { hostUrl  } = useContext(EnvVariablesContext)
  const { data, revalidate } = useWebcast(value ?? defaultState, hostUrl)
  const [ extendedValue, setExtendedValue ] = useState({
    ...data,
    revalidate
  })

  useEffect(() => {

    setExtendedValue({
      ...data,
      revalidate
    })

  }, [ data, revalidate ])

  return <Provider value={extendedValue}>{ children }</Provider>

}

export default WebcastProvider
